import { Nav } from "@/components/site/Nav";
import { Hero, HeroText } from "@/components/site/Hero";
import { Interlude } from "@/components/site/Interlude";
import { Potential } from "@/components/site/Potential";
import { SignalStates } from "@/components/site/SignalStates";
import { Science } from "@/components/site/Science";
import { Difference } from "@/components/site/Difference";
import { Startup } from "@/components/site/Startup";
import { Final } from "@/components/site/Final";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Nav />
      <Hero />
      <HeroText />
      <Potential />
      <Interlude />
      <SignalStates />
      <Science />
      <Difference />
      <Startup />
      <Final />
    </main>
  );
}
